import { t } from 'i18next'
import React, { FunctionComponent, useState, useEffect, useRef } from 'react'

import { ClinTheme } from '../../ClinTheme'
import { ClinIcon } from '../ClinIcon'
import { ClinIconPathName } from '../ClinIcon/ClinIcon.paths'
import { ClinText } from '../ClinText'
import {
  NotificationContainer,
  VerticalLine,
  DismissButton
} from './ClinNotification.styles'

interface ClinNotificationProps {
  title: string
  onClose: (e?: React.MouseEvent<HTMLButtonElement>) => void
  autoHideTimer?: number
  style?: React.CSSProperties
  className?: string
}

export const ClinNotification: FunctionComponent<ClinNotificationProps> = ({
  title,
  onClose,
  autoHideTimer = 10000,
  style,
  className
}) => {
  const [isVisible, setIsVisible] = useState(true)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const handleClose = () => {
    setIsVisible(false)
    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    onClose && onClose()
  }

  useEffect(() => {
    if (autoHideTimer > 0) {
      const timer = setTimeout(() => {
        handleClose()
      }, autoHideTimer)

      timerRef.current = timer

      return () => {
        clearTimeout(timer)
        timerRef.current = null
      }
    }
  }, [autoHideTimer])

  return (
    <>
      {isVisible && (
        <NotificationContainer
          style={style}
          className={className}
          data-testid="notification-container"
        >
          <ClinIcon
            style={{
              marginLeft: ClinTheme.space[3],
              marginTop: ClinTheme.space[2]
            }}
            iconSize={ClinTheme.fontSizes[4]}
            iconName={ClinIconPathName.Success}
            iconFill={ClinTheme.colors.aquaGreen}
            data-testid="clin-icon"
          />
          <ClinText
            fontWeight={ClinTheme.fontWeights.medium}
            fontSize={ClinTheme.fontSizes[1]}
            color={ClinTheme.colors.white}
            whiteSpace="nowrap"
            data-testid="clin-text"
          >
            {title}
          </ClinText>
          <VerticalLine data-testid="vertical-line"></VerticalLine>
          <DismissButton onClick={handleClose} data-testid="dismiss-button">
            {t('common:buttons.dismiss')}
          </DismissButton>
        </NotificationContainer>
      )}
    </>
  )
}

export default ClinNotification
